var slice = Array.prototype.slice;
// an array from an array-like (arguments, NodeList, jQuery)
export default function toArray(object) {
  return slice.call(object);
}